<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="180px">
        <el-row>
            <el-col :span="24">
                <el-form-item label="审核意见" prop="examineRadio" required>
                    <el-radio v-model="form.examineRadio" :label="3">同意开通</el-radio>
                    <el-radio v-model="form.examineRadio" :label="2">驳回开通</el-radio>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row v-if="form.examineRadio==2">
            <el-col :span="24">
                <el-form-item label="驳回理由" prop="reason" required>
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 4}"
                            placeholder="请输入理由"
                            v-model="form.reason">
                    </el-input>

                </el-form-item>

            </el-col>
        </el-row>
        <el-row style="padding-top:20px;">
            <div class="dialog-footer" style="padding-left: 40%">
                <el-button @click="closeDialog()" size="small">关 闭</el-button>
                <el-button size="small" type="primary" @click="audit('form')">确 定</el-button>
            </div>
        </el-row>
        </el-form>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {toExamine} from '@/api/admin/sysEnterprise/to-examine';
  export default {
  components: {},
  name: 'audit',
  props:["entId"],
    data() {
      return {
          form:{
              entId: null,
              examineRadio: null,
              reason: null,
          },
          rules: {
              /**新增***/
              examineRadio: [
                  {
                      required: true,
                      message: '请选择',
                      trigger: 'blur'
                  }
              ],
              reason: [
                  {
                      required: true,
                      message: '请输入',
                      trigger: 'blur'
                  }
              ],
          }
      }
    },
    created() {
        this.form.entId = this.entId;
    },
    computed: {
      ...mapGetters([
        'elements'
      ])
    },
    methods: {
        audit:function(formName){
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    toExamine(this.form).then(response=>{
                        this.$emit('success')
                    })
                } else {
                    return false;
                }
            });
        },
        closeDialog(){
            this.$emit('close')
        }
    }
  }
</script>
